import { type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./auth";

export default function RequireAuth({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}